import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const PROMO_VIDEO_ID = "nH1ETfpg34Y";

export const WatchModal = ({ open, onClose }) => {
    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={onClose}
                    className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-md flex items-center justify-center p-4"
                    data-testid="watch-modal-overlay"
                >
                    <motion.div
                        initial={{ scale: 0.95 }}
                        animate={{ scale: 1 }}
                        exit={{ scale: 0.95 }}
                        onClick={(e) => e.stopPropagation()}
                        className="relative w-full max-w-5xl aspect-video bg-black border border-[#D4AF37]/40 gold-glow"
                        data-testid="watch-modal"
                    >
                        <button
                            onClick={onClose}
                            data-testid="watch-modal-close"
                            className="absolute -top-12 right-0 h-10 w-10 border border-white/20 grid place-items-center text-white hover:text-[#D4AF37] hover:border-[#D4AF37]"
                        >
                            <X size={18} />
                        </button>
                        <iframe
                            className="absolute inset-0 w-full h-full"
                            src={`https://www.youtube.com/embed/${PROMO_VIDEO_ID}?autoplay=1&rel=0`}
                            title="EDUtainment Pros · Young Mogul Program Promo"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            data-testid="promo-video"
                        />
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
